export default __webpack_public_path__ + "images/QH.2dfec69.png";